module.exports = __webpack_public_path__ + "img/795.c2cf9430.gif";